import { View, Text } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import { formatSerialNumber } from "../constants/serialNumbers";
import {
  LTD_COMPANY_CONTRACT_FIELD_FALLBACKS,
  LTD_COMPANY_CONTRACT_FIELD_IDS,
} from "../constants/contractFields";

const SignatureBlock = ({
  styles,
  label = "Signed:",
  note = "",
  noteId,
  showDate = true,
}) => (
  <View style={[styles.flexColumn, styles.gap_xs]}>
    <View style={[styles.flexRow, { justifyContent: "space-between" }]}>
      <Text style={[styles.buttonTextSmall, { width: "48%" }]}>{label}</Text>
      {showDate && (
        <Text
          style={[styles.buttonTextSmall, { width: "48%", textAlign: "right" }]}
        >
          Date:
        </Text>
      )}
    </View>

    <View style={[styles.flexRow, { justifyContent: "space-between" }]}>
      <View
        style={{
          width: "48%",
          borderBottom: "1 solid #000000",
          minHeight: 18,
        }}
      />

      {showDate && (
        <View
          style={{
            width: "48%",
            borderBottom: "1 solid #000000",
            minHeight: 18,
          }}
        />
      )}
    </View>

    {note ? (
      <Text id={noteId} style={[styles.buttonTextSmall, styles.text_red]}>
        {note}
      </Text>
    ) : null}
  </View>
);

const LawOfTheContract = ({ contractDetails = {}, serialNumber = 10 }) => {
  const styles = ContractStyles();
  const arName =
    contractDetails.tradingName ||
    contractDetails.arName ||
    LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.arName;
  const companyName =
    contractDetails.companyName ||
    contractDetails.companyRepresentativeName ||
    LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.companyRepresentativeName;
  const lawNames = Array.isArray(contractDetails.lawOfContractNames)
    ? contractDetails.lawOfContractNames.filter(Boolean)
    : contractDetails.lawOfContractNames
      ? [contractDetails.lawOfContractNames]
      : [LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.lawOfContractName];

  const personOne =
    lawNames[0] || LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.lawOfContractName;
  const personTwo =
    lawNames[1] || LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.lawOfContractName;
  const personThree =
    lawNames[2] || LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.lawOfContractName;

  return (
      <View style={[styles.flexColumn, styles.gap_sm]} break
          id="law-of-the-contract"
      >
      <ContractListItem
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Law of the Contract
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_md, { paddingLeft: 16 }]}>
        <ContractListItem
          marker=""
          markerWidth={0}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          This Contract is governed by and shall be construed in accordance with
          the laws of England and both the Company and the Appointed
          Representative submit to the exclusive jurisdiction of the English
          Courts.
        </ContractListItem>

        <View style={[styles.flexColumn, styles.gap_sm, { marginTop: 8 }]}>
          <SignatureBlock
            styles={styles}
            noteId={LTD_COMPANY_CONTRACT_FIELD_IDS.companyRepresentativeName}
            note={`(on behalf of ${companyName} (The 'Company'))`}
          />

          <SignatureBlock
            styles={styles}
            noteId={LTD_COMPANY_CONTRACT_FIELD_IDS.lawOfContractNames}
            note={`(${personOne}, on behalf of ${arName}, 'The Appointed Representative')`}
          />

          <SignatureBlock
            styles={styles}
            noteId={LTD_COMPANY_CONTRACT_FIELD_IDS.lawOfContractName}
            note={`(${personTwo}, on behalf of ${arName}, 'The Appointed Representative')`}
          />

          <SignatureBlock
            styles={styles}
            noteId={LTD_COMPANY_CONTRACT_FIELD_IDS.lawOfContractDate}
            note={`(${personThree}, on behalf of ${arName}, 'The Appointed Representative')`}
          />
        </View>

        <Text
          style={[styles.buttonTextSmall, styles.text_red, { marginTop: 8 }]}
        >
          Add or remove above
        </Text>
      </View>
    </View>
  );
};

export default LawOfTheContract;
